import {
  TableCellType,
  TableHeader,
} from "../../../components/custom-table/table";
import { AuthStatusOptionModel } from "../../../data-model/authStatusOptions";
import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";
import { getAuthStatusOfOneJCode } from "../../../utils/getAuthStatusOfMedicalPaOrder";

export enum JCodeDocsTableHeadersKeys {
  JCODE = "jCode",
  DESCRIPTION = "description",
  DOCUMENT_UPLOADED_AT = "documentUploadedAt",
  JCODE_STATUS = "jCodeStatus",
  JCODE_DOCS = "jCodeDocs",
}

export const JCodeDocsTableTableColumns: TableHeader[] = [
  {
    label: "JCode",
    key: JCodeDocsTableHeadersKeys.JCODE,
    order: 2,
    width: 10,
    type: TableCellType.STRING,
  },
  {
    label: "Description",
    key: JCodeDocsTableHeadersKeys.DESCRIPTION,
    order: 2,
    width: 25,
    type: TableCellType.STRING,
  },
  {
    label: "Date",
    key: JCodeDocsTableHeadersKeys.DOCUMENT_UPLOADED_AT,
    order: 1,
    width: 15,
    type: TableCellType.DATE,
  },
  {
    label: "Auth Status",
    key: JCodeDocsTableHeadersKeys.JCODE_STATUS,
    order: 4,
    width: 20,
    type: TableCellType.BADGE,
  },
  {
    label: "",
    key: JCodeDocsTableHeadersKeys.JCODE_DOCS,
    order: 5,
    width: 45,
    type: TableCellType.DOC_NAME_WITH_ICON,
  },
];

export const generateJCodeDocsTableData = (
  orderData: MedicalPaOrder,
  authStatusOptions: AuthStatusOptionModel[],
) => {
  const allJCodesData = orderData?.auth_on_file?.auth_entries
    ?.map((authEntry) => authEntry.j_codes)
    .filter((jCode) => jCode && jCode?.length > 0)
    .flat();

  return allJCodesData?.map((jCode) => {
    const docs = jCode?.documents?.map((doc) => {
      return {
        docTitle: doc?.doc_title,
        docType: doc?.doc_type,
        docPath: doc?.doc_path,
        identifier: jCode?.id ?? "",
      };
    });
    const jCodeStatus = getAuthStatusOfOneJCode(jCode ?? {}, authStatusOptions);
    return {
      jCode: jCode?.j_code,
      description: jCode?.description,
      documentUploadedAt: orderData?.created_at,
      jCodeStatus: {
        text: jCodeStatus?.text,
        color: jCodeStatus?.textColor,
        bgColor: jCodeStatus?.bgColor,
      },
      jCodeDocs: docs,
    };
  });
};
